/*
  Size guide CM / INCH switch (adam, 10 Oct 2026).
  Every size chart (the size_chart metaobjects, one HTML table per style) has a CM group and an INCH group of
  columns side by side, which is too wide for phones. When the size guide opens, this script finds those two
  groups in whatever table is there and shows one at a time, with a CM | INCH switch above it. CM is the
  default; the shopper's choice is remembered for the next product. Tables without CM/INCH headings are left
  alone. Nothing in the size chart content needs editing: new charts get the switch automatically.
  Loaded once from layout/theme.liquid; works after the in-place colour switch because it uses delegated clicks.
*/
(function () {
  var KEY = 'lp-size-unit';
  // Default unit by market (adam, 12 Oct 2026): INCH for the USA and Canada, CM everywhere else (Australia, UK ...).
  // A shopper's own tap on CM / INCH is remembered and always wins over the market default.
  var INCH_MARKETS = { US: 1, CA: 1 };
  function marketUnit() { var c = window.Shopify && window.Shopify.country; return c && INCH_MARKETS[String(c).toUpperCase()] ? 'inch' : 'cm'; }
  function getUnit() { try { var s = localStorage.getItem(KEY); if (s === 'inch' || s === 'cm') return s; } catch (e) {} return marketUnit(); }
  function setUnit(u) { try { localStorage.setItem(KEY, u); } catch (e) {} }

  // Give every cell its real starting column, allowing for colspan and rowspan.
  function mapColumns(table) {
    var rows = table.rows, taken = [], cells = [];
    for (var r = 0; r < rows.length; r++) {
      taken[r] = taken[r] || [];
      var c = 0;
      for (var i = 0; i < rows[r].cells.length; i++) {
        var cell = rows[r].cells[i];
        while (taken[r][c]) c++;
        var span = cell.colSpan || 1, down = cell.rowSpan || 1;
        for (var dr = 0; dr < down; dr++) { taken[r + dr] = taken[r + dr] || []; for (var dc = 0; dc < span; dc++) taken[r + dr][c + dc] = true; }
        cells.push({ el: cell, start: c, end: c + span - 1 });
        c += span;
      }
    }
    return cells;
  }

  function enhance(table) {
    if (table.getAttribute('data-lp-units')) return;
    table.setAttribute('data-lp-units', 'none');
    var cells = mapColumns(table), cm = null, inch = null;
    cells.forEach(function (x) {
      var t = (x.el.textContent || '').replace(/\s+/g, '').toUpperCase();
      if (!cm && t === 'CM') cm = x;
      if (!inch && (t === 'INCH' || t === 'INCHES' || t === 'IN')) inch = x;
    });
    if (!cm || !inch) return;
    cells.forEach(function (x) {
      if (x.start >= cm.start && x.end <= cm.end) x.el.setAttribute('data-lp-unit', 'cm');
      else if (x.start >= inch.start && x.end <= inch.end) x.el.setAttribute('data-lp-unit', 'inch');
    });
    // The switch now names the unit, so hide the CM / INCH heading cells and let the chart name
    // (e.g. "IRIS SIZE GUIDE") run across the whole first row (adam, 12 Oct 2026).
    cm.el.setAttribute('data-lp-unit-head', '');
    inch.el.setAttribute('data-lp-unit-head', '');
    // The chart name (e.g. "DEMI SIZE GUIDE") moves into the empty first cell of the sizes row, so the name and
    // XS, S, M, L share one row and the old heading row is hidden (adam, 12 Oct 2026, option B).
    var headRow = cm.el.parentElement, title = null;
    cells.forEach(function (x) { if (!title && x.el.parentElement === headRow && x.end < cm.start) title = x; });
    var sizeRow = table.rows[Array.prototype.indexOf.call(table.rows, headRow) + 1];
    if (title && sizeRow) {
      var slot = null;
      cells.forEach(function (x) { if (!slot && x.el.parentElement === sizeRow && x.start === title.start) slot = x.el; });
      if (!slot) slot = sizeRow.insertCell(0); // the name cell used to span this row (e.g. Amelia)
      slot.innerHTML = title.el.innerHTML;
      slot.classList.add('lp-chart-title');
      headRow.classList.add('lp-head-row');
      sizeRow.classList.add('lp-size-row');
    }
    // Steady columns (adam, 12 Oct): each size column gets an equal share set by the number of sizes, not by its
    // figures, and the first column takes just what its longest label needs. Labels are the same in both units,
    // so nothing moves when switching CM / INCH.
    table.style.setProperty('--lp-col', (100 / (cm.end - cm.start + 1)) + '%');
    table.setAttribute('data-lp-units', 'on');
    var sw = document.createElement('div');
    sw.className = 'lp-unit-switch';
    sw.setAttribute('role', 'group');
    sw.setAttribute('aria-label', 'Measurement units');
    sw.innerHTML = '<button type="button" data-lp-set-unit="cm">CM</button><button type="button" data-lp-set-unit="inch">INCH</button>';
    table.parentNode.insertBefore(sw, table);
    apply(getUnit());
  }

  function apply(unit) {
    var tables = document.querySelectorAll('table[data-lp-units="on"]');
    for (var i = 0; i < tables.length; i++) { tables[i].classList.toggle('lp-show-inch', unit === 'inch'); tables[i].classList.toggle('lp-show-cm', unit !== 'inch'); }
    var btns = document.querySelectorAll('[data-lp-set-unit]');
    for (var j = 0; j < btns.length; j++) btns[j].setAttribute('aria-pressed', btns[j].getAttribute('data-lp-set-unit') === unit ? 'true' : 'false');
  }

  function enhanceAll() {
    var ts = document.querySelectorAll('.size-chart-table-wrap table');
    for (var i = 0; i < ts.length; i++) enhance(ts[i]);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-lp-set-unit], .popup-btn') : null;
    if (!t) return;
    if (t.hasAttribute('data-lp-set-unit')) { var u = t.getAttribute('data-lp-set-unit'); setUnit(u); apply(u); }
    else enhanceAll();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceAll); else enhanceAll();
})();
